import { createFileRoute } from "@tanstack/react-router";
import TreatingDepression from "@/pages/TreatingDepression";
export const Route = createFileRoute(
  "/contents/conditions/depression/treating-depression",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Treating Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Compare traditional antidepressant medications & psychotherapy with advanced alternative depression treatments like TMS, SAINT®, SPRAVATO®, and IV Ketamine.",
        },
        {
          property: "og:title",
          content: "Treating Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Compare traditional antidepressant medications & psychotherapy with advanced alternative depression treatments like TMS, SAINT®, SPRAVATO®, and IV Ketamine.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/contents/conditions/depression/treating-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/contents/conditions/depression/treating-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TreatingDepression />;
}
